export default __webpack_public_path__ + "static/media/guacamayoEscarlata.94d1f0d4.jpg";